// 设置用户
export const SET_USER_STATE = 'SET_USER_STATE';
// 设置聊过天的所有用户的头像、昵称
export const SET_USER_MAP = 'SET_USER_MAP';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js